

import Vue from "vue";
import App from "./App";
import router from "./router";
import "@/styles/index.scss"; 
import "./main.css";

import i18n from "@/lang"; 
import mandMobile from "mand-mobile";
import "mand-mobile/lib-vw/mand-mobile.css";
import Antd from "ant-design-vue";
import "ant-design-vue/dist/antd.css";

import ToastPlugin from 'vux/src/plugins/toast/index.js'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'
import AlertPlugin from 'vux/src/plugins/alert/index.js'
import DatetimePlugin from 'vux/src/plugins/datetime/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'


import infiniteScroll from "vue-infinite-scroll";
import FastClick from "fastclick";
import * as directives from "./directives"; 

import VideoPlayer from "vue-video-player";
require("video.js/dist/video-js.css");
require("vue-video-player/src/custom-theme.css");

Vue.use(ToastPlugin, { position: "middle", time: 3000 });
Vue.use(ConfirmPlugin);
Vue.use(AlertPlugin);
Vue.use(DatetimePlugin);
Vue.use(LoadingPlugin);
Vue.use(infiniteScroll);
Vue.use(mandMobile);
Vue.use(VideoPlayer);
Vue.use(Antd);

FastClick.attach(document.body);


Object.keys(directives).forEach(key => Vue.directive(key, directives[key]));

Vue.config.productionTip = false;

Vue.config.ignoredElements = ["wx-open-launch-app"];

/* eslint-disable no-new */
new Vue({
el: "#app-box",
router,
i18n,
render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js